var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsLightroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.852,
    viewBox: "0 0 46 44.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_lightroom",
    transform: "translate(-1172 -914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M8.145,0h29.71A8.139,8.139,0,0,1,46,8.145V36.707a8.139,8.139,0,0,1-8.145,8.145H8.145A8.139,8.139,0,0,1,0,36.707V8.145A8.139,8.139,0,0,1,8.145,0Z",
    transform: "translate(1172 914)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M77.64,84.289H65.495c-.215,0-.3-.108-.3-.341V64.357a.241.241,0,0,1,.215-.269h3.821a.185.185,0,0,1,.215.161V80.4H78.3c.2,0,.251.09.215.269L77.963,84a.356.356,0,0,1-.108.233A.478.478,0,0,1,77.64,84.289Z",
    transform: "translate(1118.508 861.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M150.7,89.789h3.355a.4.4,0,0,1,.395.3,1.656,1.656,0,0,1,.161.449c.036.2.072.395.09.592.018.215.036.449.036.682a7.6,7.6,0,0,1,2.045-1.651,5.5,5.5,0,0,1,2.853-.682.241.241,0,0,1,.269.215V93.52c0,.161-.09.215-.3.215a8.081,8.081,0,0,0-3.624.646,3.182,3.182,0,0,0-1.041.718v9.778c0,.2-.072.269-.251.269h-3.732a.257.257,0,0,1-.3-.233V94.22c0-.466,0-.933-.018-1.435s-.018-1-.036-1.489c-.018-.431-.054-.843-.108-1.274a.185.185,0,0,1,.126-.215c.036-.036.054-.036.09-.018Z",
    transform: "translate(1048.516 840.573)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsLightroom);
export default __webpack_public_path__ + "static/media/skills_lightroom.639b85de7adfd3e45a76e427651acca0.svg";
export { ForwardRef as ReactComponent };